__turbopack_context__.v({
  "alignCenter": "SurveyBrand-module__RIZAGq__alignCenter",
  "alignLeft": "SurveyBrand-module__RIZAGq__alignLeft",
  "alignRight": "SurveyBrand-module__RIZAGq__alignRight",
  "brand": "SurveyBrand-module__RIZAGq__brand",
  "contact": "SurveyBrand-module__RIZAGq__contact",
  "footer": "SurveyBrand-module__RIZAGq__footer",
  "header": "SurveyBrand-module__RIZAGq__header",
  "logo": "SurveyBrand-module__RIZAGq__logo",
  "logoText": "SurveyBrand-module__RIZAGq__logoText",
  "org": "SurveyBrand-module__RIZAGq__org",
});
